import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-update-work',
  templateUrl: './update-work.component.html',
  styleUrls: ['./update-work.component.scss']
})
export class UpdateWorkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
